export { default as CoreTextField } from './text-field';
export type {
  CoreTextFieldProps,
  CoreTextFieldType,
  IconPosition,
} from '../shared/types/text-field.types';
